export default __webpack_public_path__ + "static/media/No77.6850abe7.png";